<template>
  <div
    v-if="showForm"
    class="z-50 flex items-center justify-center fixed top-0 left-0 w-full h-full bg-black bg-opacity-80"
  >
    <div class="box-border w-[500px] bg-white p-6 rounded-lg relative !z-999">
      <button
        @click="handleButtonClick"
        class="absolute top-0 right-0 -mt-4 -mr-4 p-2 bg-gray-200 rounded-full hover:bg-gray-300 focus:outline-none"
      >
        <svg
          class="w-6 h-6 text-gray-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </button>

      <!-- Thank You Message -->
      <!-- <div v-if="submissionStatus === 'success'" class="text-center">
        <h3 class="text-center text-black text-[24px] font-medium">
          Thank You!
        </h3>
        <p>
          Your Enquiry has been submitted successfully. Our admissions team will
          get in touch with you soon. A verification email has been sent to your
          registered email ID. Please ignore if already verified.
        </p>
      </div> -->

      <!-- Form -->
      <div>
        <h3 class="text-center text-black text-[24px] font-medium">
          Enquire Now
        </h3>
        <form @submit.prevent="submitForm">
          <div class="flex flex-col gap-4 pt-3">
            <div
              class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 focus-within:border-blue-500"
            >
              <input
                type="text"
                name="name"
                id="name"
                autocomplete="off"
                class="form-control widget_input w-full border-none focus:outline-none focus:ring-0"
                maxlength="255"
                minlength="1"
                placeholder="Name *"
                required
                v-model="name"
                v-on:input="validateInput"
              />
            </div>
            <div
              class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 focus-within:border-blue-500"
            >
              <input
                class="w-full border-none focus:outline-none focus:ring-0"
                type="email"
                name="email"
                id="email"
                autocomplete="off"
                maxlength="50"
                placeholder="Email *"
                required
                v-model="email"
              />
            </div>
            <div
              class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 rounded-md focus-within:border-blue-500 relative"
            >
              <div class="flex">
                <select
                  id="country-form"
                  v-model="selectedCountryCode"
                  @change="handleChange"
                  class="form-control widget_input w-20 h-8 bg-gray-200 text-center"
                >
                  <option
                    v-for="country in countryCodes"
                    :key="country.code"
                    :value="country.code"
                  >
                    {{
                      selectedCountryCode === country.code
                        ? country.code
                        : `${country.name} (${country.code})`
                    }}
                  </option>
                </select>
                <input
                  type="tel"
                  name="mobile"
                  id="Mobile"
                  autocomplete="off"
                  maxlength="10"
                  class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 pl-2"
                  pattern="[0-9]*"
                  placeholder="Mobile *"
                  onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
                  v-model="phoneNumber"
                  required
                />
                <!-- <p type="button" class="absolute right-5 pt-2 text-xs" :class="{
                  'text-[#0A2767]': !otpCooldown,
                  'text-green-700': otpCooldown,
                  'cursor-pointer': !otpCooldown && phoneNumber.length === 10,
                  'opacity-50 cursor-not-allowed':
                    otpCooldown || phoneNumber.length !== 10,
                }" @click="getOtp" :disabled="otpCooldown || phoneNumber.length !== 10">
                  {{ otpCooldown ? "OTP Sent" : "Get OTP" }}
                </p> -->
              </div>
            </div>
            <!-- <div
              class="relative box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 focus-within:border-blue-500 flex items-center">
              <input type="tel" name="otp" id="otp" autocomplete="off" maxlength="6"
                class="form-control widget_input w-full border-none focus:outline-none focus:ring-0 pr-16"
                pattern="[0-9]*" placeholder="OTP *" v-model="enteredOtp" @input="sanitizeInput"  />

              
              <button :disabled="isButtonDisabled" @click="verifyOtp"
                class="absolute right-1 top-1/2 transform -translate-y-1/2 px-2 py-1 bg-[#0A2767] text-white rounded-md disabled:bg-gray-300 text-xs">
                Verify
              </button>
            </div> -->
            <!-- <div v-if="submissionStatus === 'otpError'" class="text-red-500 text-xs text-left pl-0 mt-1">
              Invalid OTP
            </div> -->
            <div class="flex gap-4">
              <div
                class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 flex-1 focus-within:border-blue-500"
              >
                <select
                  name="program"
                  id="SelectProgram"
                  class="form-control widget_input w-full bg-white border-none focus:outline-none focus:ring-0"
                  v-model="selectedProgram"
                  @change="handleProgramChange"
                  :disabled="isDisabled"
                  :style="{
                    color: isDisabled ? 'gray' : '#333',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }"
                  required
                >
                  <option value="" disabled>Select Program *</option>
                  <option
                    v-for="program in allPrograms"
                    :key="program.id"
                    :value="program.slug"
                  >
                    {{ program.name }}
                  </option>
                </select>
              </div>
              <div
                class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 flex-1 focus-within:border-blue-500"
              >
                <select
                  name="elective"
                  id="SelectElective"
                  class="form-control widget_input w-full bg-white border-none focus:outline-none focus:ring-0"
                  v-model="selectedElective"
                  :disabled="isDisabled"
                  :style="{
                    color: isDisabled ? 'gray' : '#333',
                    cursor: isDisabled ? 'not-allowed' : 'pointer',
                  }"
                  required
                >
                  <option value="" disabled>Select Elective *</option>
                  <option
                    v-for="elective in filteredElectives"
                    :key="elective.id"
                    :value="elective.slug"
                  >
                    {{ elective.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex gap-4">
              <div
                v-if="selectedCountryCode === '+91'"
                class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 flex-1 focus-within:border-blue-500"
              >
                <select
                  name="state"
                  id="SelectState"
                  class="form-control widget_input w-full bg-white border-none focus:outline-none focus:ring-0"
                  v-model="selectedState"
                  @change="onStateChange"
                  required
                >
                  <option value="" disabled selected>Select State *</option>
                  <option
                    v-for="state in stateList"
                    :key="state.state"
                    :value="state.state"
                  >
                    {{ state.state }}
                  </option>
                </select>
              </div>
              <div
                v-if="selectedCountryCode === '+91'"
                class="box-border text-[14px] leading-normal text-[#333] border border-gray-300 p-1 rounded-md h-8 flex-1 focus-within:border-blue-500"
              >
                <select
                  name="city"
                  id="SelectCity"
                  class="form-control widget_input w-full bg-white border-none focus:outline-none focus:ring-0"
                  v-model="selectedCity"
                  :disabled="!cities.length"
                  required
                >
                  <option value="" disabled selected>Select City *</option>
                  <option v-for="city in cities" :key="city" :value="city">
                    {{ city }}
                  </option>
                </select>
              </div>
            </div>
            <div
              class="box-border text-[14px] leading-normal text-start text-[#333] p-1"
            >
              <label class="flex items-start space-x-2">
                <input
                  type="checkbox"
                  name="consent"
                  class="mt-1 focus:ring-blue-500"
                  required
                />
                <span
                  >I authorize JAIN Online and its associates to contact me with
                  updates & notifications via email, SMS, WhatsApp, and voice
                  call. This consent will override any registration for
                  DNC/NDNC.</span
                >
              </label>
            </div>
            <div
              class="box-border text-[14px] leading-normal text-[#333] text-center p-1"
            >
              <button
                type="submit"
                class="w-full px-4 py-2 bg-[#0A2767] text-white rounded-md hover:bg-blue-700 focus:outline-none focus:bg-blue-700"
              >
                Submit
              </button>
            </div>
            <div>
              <span
                v-if="submissionStatus === 'error'"
                class="text-red-500 text-xs"
                >{{ errorMessage }}</span
              >
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import stateMixins from "@/mixins/stateMixins";
import countryCodeMixins from "@/mixins/countryCodeMixins";

export default {
  name: "EnquireView",
  mixins: [stateMixins, countryCodeMixins],
  data() {
    return {
      showForm: true,
      programs: [],
      electives: [],
      formVisible: true,
      filteredElectives: [],
      name: "",
      email: "",
      selectedProgram: "",
      selectedElective: "",
      selectedState: "",
      selectedCity: "",
      cities: [],
      phoneNumber: "",
      enteredOtp: "",
      isButtonDisabled: false,
      otpSent: false,
      errorStatus: false,
      errorMessage: "",
      selectedCountryCode: "+91",
      submissionStatus: "",
      otpCooldown: false,
      isAutoSelected: false,
      isDisabled: false,
      allPrograms: [],
    };
  },

  props: {
    showForm: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    this.fetchProgramsAndElectives();
    this.autoSelectProgramAndElective();
  },

  methods: {
    closeForm() {
      this.$emit("close-form");
      this.formVisible = false;
      this.resetForm();
    },
    validateInput(event) {
      const regex = /^[A-Za-z\s]*$/;
      if (!regex.test(event.target.value)) {
        event.target.value = event.target.value.replace(/[^A-Za-z\s]/g, "");
      }
      this.name = event.target.value;
    },
    onStateChange() {
      const state = this.stateList.find((s) => s.state === this.selectedState);
      this.cities = state ? state.districts : [];
      this.selectedCity = "";
    },
    sanitizeInput() {
      this.enteredOtp = this.enteredOtp.replace(/[^0-9]/g, "");
    },
    async verifyOtp() {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_LEADAPI}/lead/otp/verify/phone`,
          {
            phone: `${this.selectedCountryCode}${this.phoneNumber}`,
            otp: this.enteredOtp,
          }
        );
        if (response.data.success) {
          this.isButtonDisabled = true; // Disable button on success
        } else {
          alert(response.data.message || "OTP verification failed.");
        }
      } catch (error) {
        console.error("Error verifying OTP:", error);
      }
    },
    onPhoneNumberChange() {
      this.message = "";
      this.otpSent = false;
      this.phoneNumber = this.phoneNumber.replace(/\D/g, "");
      if (this.phoneNumber.length > 10) {
        this.phoneNumber = this.phoneNumber.slice(0, 10);
      }
    },
    handleKeyPress(event) {
      if (
        !(event.charCode >= 48 && event.charCode <= 57) &&
        event.charCode !== 8
      ) {
        event.preventDefault();
      }
    },
    async getOtp() {
      if (this.phoneNumber.length !== 10 || this.otpCooldown) {
        return;
      }
      try {
        const json_data = {
          phone: `${this.selectedCountryCode}${this.phoneNumber}`,
        };
        const response = await axios.post(
          `${process.env.VUE_APP_LEADAPI}/lead/otp/send/phone`,
          json_data
        );
        this.otpSent = true;
        this.otpCooldown = true;
        this.startOtpCooldown();
      } catch (error) {
        console.error("Error getting OTP:", error);
      }
    },
    startOtpCooldown() {
      setTimeout(() => {
        this.otpSent = false;
        this.otpCooldown = false;
      }, 30000); // 30 seconds cooldown
    },
    async submitForm() {
      this.errorStatus = false;
      this.submissionStatus = "";
      try {
        const formData = {
          name: this.name,
          email: this.email,
          phone: `${this.selectedCountryCode}${this.phoneNumber}`,
          programName: this.selectedProgram,
          programElective: this.selectedElective,
          state: this.selectedState,
          city: this.selectedCity,
          university: "jain",
          utmCampaign: this.$route.query.utm_campaign || "",
          utmSource: this.$route.query.utm_source || "",
          utmMedium: this.$route.query.utm_medium || "",
          utmPlacement: this.$route.query.utm_placement || "",
          utmAdgroupId: this.$route.query.utm_adgroupid || "",
          utmCreativeId: this.$route.query.utm_creativeid || "",
          utmDevice: this.$route.query.utm_device || "",
          utmNetwork: this.$route.query.utm_network || "",
          utmCampaignId: this.$route.query.utm_campaignid || "",
          utmMatchType: this.$route.query.utm_matchype || "",
          utmKeyword: this.$route.query.utm_keyword || "",
          utmChannel: "Enquire Now" || "",
          utmURL: window.location.href || "",
        };

        const response = await axios.post(
          `${process.env.VUE_APP_LEADAPI}/lead/`,
          formData
        );
        const responseData = response.data;
        if (responseData.lead.success === true) {
          this.submissionStatus = "success";
          // Hide the form and show thank you message
          this.showForm = false;
          dataLayer.push({
            event: "Enquiry Form Filled",
            Attribute: {
              Name: this.name,
              Email: this.email,
              Phone: this.phoneNumber,
              Elective: this.selectedElective,
              Program: this.selectedProgram,
              State: this.selectedState,
              City: this.selectedCity,
              "Contact Permission": "true",
            },
          });

          if (responseData.url) {
            window.location.href = responseData.url;
          } else {
            this.userMessage = "Redirect URL not found in the response.";
            setTimeout(() => {
              this.userMessage = "";
            }, 3000);
          }
        } else {
          console.error("Form submission error:", responseData);
          if (
            responseData.status === 400 &&
            responseData.message === "failure" &&
            responseData.alert === "Invalid OTP"
          ) {
            this.submissionStatus = "otpError";
          } else {
            this.submissionStatus = "error";
            this.errorMessage =
              responseData.data.data.error_list.common ||
              responseData.data.message;
          }
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          console.error("Form submission error:", error.response.data);
          if (
            error.response.data.message === "failure" &&
            error.response.data.alert === "Invalid OTP"
          ) {
            this.submissionStatus = "otpError";
          } else {
            this.submissionStatus = "error";
            this.errorMessage =
              error.response.data.data.error_list.common ||
              error.response.data.message;
          }
        } else {
          console.error("Unexpected error during form submission:", error);
          this.submissionStatus = "error";
          this.errorMessage = "An unexpected error occurred. Please try again.";
        }
      }
    },
    resetForm() {
      this.showForm = false;
      this.submissionStatus = "";
      this.name = "";
      this.email = "";
      this.selectedState = "";
      this.selectedCity = "";
      this.phoneNumber = "";
      this.enteredOtp = "";
      this.otpSent = false;
      this.otpCooldown = false;
      this.errorStatus = false;
      this.errorMessage = "";
      this.selectedCountryCode = "+91";
    },

    handleButtonClick() {
      this.closeForm();
    },
    async fetchProgramsAndElectives() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_LEADAPI}/university/?university_slug=jain-online-website`
        );
        const universityData = response.data.data[0];
        const programs = universityData.programs.map((program) => ({
          id: program._id,
          name: program.program_name,
          slug: program.program_slug,
          electives: program.program_elective.map((elective) => ({
            id: elective._id,
            name: elective.elective_name,
            slug: elective.elective_slug,
          })),
        }));

        this.allPrograms = programs;
      } catch (error) {
        console.error("Error fetching programs and electives:", error);
      }
    },
    filterElectives() {
      if (this.selectedProgram) {
        const selectedProgram = this.allPrograms.find(
          (program) => program.slug === this.selectedProgram
        );
        this.filteredElectives = selectedProgram
          ? selectedProgram.electives
          : [];
      } else {
        this.filteredElectives = [];
      }
    },
    autoSelectProgramAndElective() {
      if (this.$route.path === "/online-mcom/financial-markets") {
        const program = this.allPrograms.find((p) => p.name === "MCOM");
        if (program) {
          this.selectedProgram = program.slug;
          this.filterElectives(); // Ensure electives are updated

          const elective = program.electives.find(
            (e) => e.name === "Financial Markets"
          );
          if (elective) {
            this.selectedElective = elective.slug;
          }
        }
        this.isDisabled = true; // Disable dropdowns
      } else {
        this.isDisabled = false;
      }
    },
  },
  watch: {
    selectedProgram() {
      this.filterElectives();
    },
    allPrograms: {
      handler() {
        this.autoSelectProgramAndElective();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.absolute {
  position: absolute;
}

.relative {
  position: relative;
}
</style>
